import {IContestant} from "../typings/IContestant";
import {Model} from "./Model";
import {IApiUser} from "../typings/apiResponse";

export interface IUser extends IContestant {
    getAlias(): string
    getNickname(): string
    getPremium(): boolean
    getLevel(): number
    getAwards(): number
    getTrustLevel(): number
}

export class User extends Model implements IUser {

    constructor(private apiData: IApiUser) {
        super(apiData);
    }

    public getId(): string {
        return this.apiData.id;
    }

    public getAlias(): string {
        return this.apiData.alias;
    }

    public getNickname(): string {
        return this.apiData.nickname;
    }

    public getName(): string {
        return this.getNickname();
    }

    public getRegion(): string {
        return this.apiData.region;
    }

    public getHomepage(): string {
        return this.apiData.homepage;
    }

    public getPenaltyPoints(): number {
        if (typeof this.apiData.penaltyPoints !== 'undefined') {
            return this.apiData.penaltyPoints;
        }

        return 0;
    }

    public getPhoto(): string {
        return this.apiData.photo;
    }

    public getPremium(): boolean {
        return this.apiData.premium;
    }

    public getTrustLevel(): number {
        return this.apiData.trustLevel;
    }

    public getLevel(): number {
        return this.apiData.level;
    }

    public getAwards(): number {
        return this.apiData.awards;
    }

    public isBarred(): boolean {
        return this.apiData.isBarred;
    }

    public getBarredUntil(): Date {
        return new Date(this.apiData.barredUntil);
    }
}
